<template>
  <v-layout class="mission-container" column style="min-height: 100%;">
    <div class="grow" style="position:relative">
      <v-layout class="map-container" fill-height v-resize="resizeMap">    
          <map-control uiid="map_global" />
          <simulation-map ref="map" >
            <slot></slot>
          </simulation-map>                   
      </v-layout>        
    </div>
  </v-layout>
</template>
<script lang="ts">


import Vue from 'vue'
import Component from 'vue-class-component'
import SimulationMap from '@/components/map/SimulationMap.vue'
import MapControl from '@/components/map/MapControl.vue'

import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'

  
@Component({
  name: 'SimulationSearch',
  components:{SimulationMap,MapControl} 
})
export default class SimulationSearch extends Vue {      


  resizeMap(){                    
    //console.log("resizeMap")
    //@ts-ignore
    if(this.$refs.map) this.$refs.map.updateSize()        
  }

  missionGlobalLoading = true  
    
  created() {                 
    //TODO Filtrage temporaire à enlever une fois le webservice securisé  
    Promise.all([
      this.$store.myActions.MISSIONVIRTUAL_ENSURE_LIST(),
      this.$store.myActions.COVERAGEITERATION_ENSURE_LIST(),      
      this.$store.myActions.MISSIONGLOBAL_ENSURE_LIST()
    ])
      .finally(()=> this.missionGlobalLoading = false)
  }   
  
  mounted() {          
    setTimeout(() => this.resizeMap(),2000)
  }

 
}

</script> 